<div *ngIf="showAlert">
    <alert [type]="type" [dismissOnTimeout]="timeout" (onClosed)="onCloseAlert()" [dismissible]="true" class="alert">
        {{ message }}</alert>
</div>
